import { inr } from "@/lib/api";

export const pctOff = (strike, offer) => {
  const s = Number(strike), o = Number(offer);
  return s > 0 && o > 0 && s > o ? Math.round(((s - o) * 100) / s) : 0;
};

// Patient-facing price: offer price (billed) + struck-off price + % off
export function PriceTag({ strike, offer, unit, className = "", testId }) {
  const off = pctOff(strike, offer);
  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-1.5 ${className}`} data-testid={testId}>
      {off > 0 && <span className="text-xs muted line-through" data-testid={testId && `${testId}-strike`}>{inr(strike)}</span>}
      <b data-testid={testId && `${testId}-offer`}>{inr(offer)}</b>
      {unit && <span className="muted text-xs">{unit}</span>}
      {off > 0 && <span className="text-[11px] font-semibold rounded-full bg-[#086B2D]/10 text-[#086B2D] px-1.5 py-0.5" data-testid={testId && `${testId}-off`}>{off}% off</span>}
    </span>
  );
}

// Form helper shown to partners/doctors while typing
export function OffHint({ strike, offer, who = "Patients", testId }) {
  const s = Number(strike), o = Number(offer);
  if (!o) return <p className="text-xs muted" data-testid={testId}>Enter the offer price – this is the amount billed.</p>;
  if (strike !== "" && strike != null && s > 0 && s < o) return <p className="text-xs text-red-700" data-testid={testId}>Strikethrough price must be higher than the offer price.</p>;
  const off = pctOff(s, o);
  return <p className={`text-xs ${off ? "text-[#086B2D] font-medium" : "muted"}`} data-testid={testId}>
    {off ? <>{who} will see <span className="line-through">{inr(s)}</span> <b>{inr(o)}</b> · {off}% off</> : <>{who} will see {inr(o)} (no discount shown)</>}
  </p>;
}
